import { BaseModel } from './base';

export class TravelAllowance extends BaseModel {
  id: string;
  allowanceName: string;
  _id: string;
}
